module.exports = __webpack_public_path__ + "static/media/create.2354eb88.svg";